import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { useSaturated } from '@/store';
import { clearQueueFairSession } from '@/utils/queueFair';

function QueueFair({ order = '' }) {
  const router = useRouter();

  const { isEnabled } = useSaturated();

  const isLastPage = router.pathname === '/success';
  const isHomePage = router.pathname === '/';

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handleScript = () => {
      if (isLastPage) {
        clearQueueFairSession();
        return;
      }

      if (isHomePage) {
        if (order && isEnabled) {
          clearQueueFairSession();
          window.location.reload();
        }
      }

      const existingScript = document.querySelector(
        'script[src="https://files.queue-fair.net/queue-fair-adapter.js"]',
      );

      if (existingScript) {
        return;
      } // Ya existe, no hacer nada

      const script = document.createElement('script');

      script.src = 'https://files.queue-fair.net/queue-fair-adapter.js';
      script.setAttribute('data-queue-fair-client', 'boletia');
      script.async = true;

      document.body.appendChild(script);

      return () => {
        if (document.body.contains(script)) {
          document.body.removeChild(script);
        }
      };
    };

    return handleScript();
  }, [isLastPage, isHomePage]);
}

export default QueueFair;
